import { clsx } from 'clsx';
import { Button, Modal } from '@material-ui/core';

import makeClasses from './ModalCenterInPage.style';

import type { ReactElement, ReactNode } from 'react';
import type { ButtonProps, ModalProps } from '@material-ui/core';

export function ModalCenterInPage(props: Props) {
  const { title, children, paragraphs, actions, classes, ...restProps } = props;

  const _isTitleAsString = typeof title === 'string';
  const _isP1AsString = typeof paragraphs?.first === 'string';
  const _isP2AsString = typeof paragraphs?.second === 'string';

  const _classes = makeClasses();

  return (
    <Modal {...restProps}>
      <div className={clsx(_classes.root, classes?.root)}>
        <header className={clsx(_classes.header, classes?.header)}>
          {_isTitleAsString ? (
            <h1 className={clsx(_classes.title, classes?.title)}>{title}</h1>
          ) : (
            title
          )}
        </header>

        <main className={clsx(_classes.main, classes?.main)}>
          {children ?? (
            <>
              {_isP1AsString ? <p>{paragraphs.first}</p> : paragraphs?.first}
              {_isP2AsString ? <p>{paragraphs.second}</p> : paragraphs?.second}
            </>
          )}
        </main>

        <footer className={clsx(_classes.footer, classes?.footer)}>
          <Button
            fullWidth
            variant='outlined'
            className={_classes.btnClose}
            {...actions?.secondaryBtn}
          />
          <Button
            fullWidth
            variant='contained'
            className={_classes.btnCTA}
            {...actions?.primaryBtn}
          />
        </footer>
      </div>
    </Modal>
  );
}

interface Props extends Omit<ModalProps, 'title' | 'children'> {
  title: ReactNode;
  // has priority over paragraphs
  children?: ReactElement;
  paragraphs?: {
    first?: ReactNode;
    second?: ReactNode;
  };
  actions?: {
    primaryBtn?: ButtonProps;
    secondaryBtn?: ButtonProps;
  };
  classes?: Partial<
    Record<'root' | 'header' | 'title' | 'main' | 'footer', string>
  >;
}
